export const mousemove = function(){

window.addEventListener(`mousemove`,(e)=>{
    console.log(`X`+e.clientX);
    console.log(`Y`+e.clientY);
});
}